module.exports = __webpack_public_path__ + "static/assets/750c3f00bfbfb4131eeb1c71e1bcc8f4.gif";